import Link from "next/link";
import { Icon, IconName } from "@nju/icons";
import { A, Text } from "@nju/ui";

interface IButtonProps {
  title: string;
  iconName: IconName;
  path: string;
  onClick?: () => void;
  testId?: string;
  target?: string;
}

export function Button({
  title,
  iconName,
  path,
  testId,
  onClick,
  target,
}: IButtonProps) {
  return (
    <Link href={path} passHref={true} target={target}>
      <A
        data-cy={testId}
        display={{
          "@onlyMobile": "block",
        }}
        onClick={onClick}
        size="inline"
        variant="neutral"
      >
        <div className="flex items-center gap-3 border-1 border-geyser rounded-button px-3 py-2 cursor-pointer only-mobile:justify-between">
          <div className="flex items-center">
            <Icon
              className="mr-3"
              height={24}
              name={iconName}
              tone="accent"
              width={24}
            />
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
            >
              {title}
            </Text>
          </div>
          <Icon height={18} name="arrow-right" tone="accent" width={24} />
        </div>
      </A>
    </Link>
  );
}
